var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loginHouseCount > _vm.houseCountVariable
    ? _c(
        "div",
        {
          staticClass: "sticky",
          attrs: { "data-sticky-enable": "login-count" },
        },
        [
          _c("div", [
            _c(
              "button",
              {
                staticClass: "btn unlock_container",
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#register",
                  type: "button",
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "17",
                      height: "16",
                      viewBox: "0 0 17 16",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        opacity: ".3",
                        d: "M4.5 13.335h8V6.668h-8v6.667zm4-4.667c.733 0 1.333.6 1.333 1.333 0 .734-.6 1.334-1.333 1.334s-1.333-.6-1.333-1.334c0-.733.6-1.333 1.333-1.333z",
                        fill: "#008489",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M12.5 5.335h-.667V4a3.335 3.335 0 0 0-6.666 0v1.334H4.5c-.733 0-1.333.6-1.333 1.333v6.667c0 .733.6 1.333 1.333 1.333h8c.733 0 1.333-.6 1.333-1.333V6.668c0-.733-.6-1.333-1.333-1.333zM6.5 4c0-1.106.893-2 2-2s2 .894 2 2v1.334h-4V4zm6 9.334h-8V6.668h8v6.667zm-4-2c.733 0 1.333-.6 1.333-1.334 0-.733-.6-1.333-1.333-1.333s-1.333.6-1.333 1.333c0 .734.6 1.334 1.333 1.334z",
                        fill: "#008489",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("span", {
                  staticClass: "subtitle-header",
                  domProps: { innerHTML: _vm._s(_vm.renderMarkdownText) },
                }),
              ]
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }